import { BaseQueryFn } from '@reduxjs/toolkit/query'
import axios, { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios'
import { globalToaster } from 'components/elements/global'
import { http } from 'lib/http'
import { RootState } from 'store'
import { ApiResponce } from 'types'

type AxioQueryArg = {
 url: string
 method?: AxiosRequestConfig['method']
 body?: AxiosRequestConfig['data']
}
const dynamicAxiosBaseQuery =
 (from?: 'precon'): BaseQueryFn<AxioQueryArg | string, unknown, unknown> =>
 async (arg, { getState, signal }) => {
  const source = axios.CancelToken.source()
  signal.addEventListener('abort', () => {
   source.cancel()
  })
  try {
   const { token } = (getState() as RootState).auth
   const { listing_url, precondo_url } = (getState() as RootState).global
   const { data }: AxiosResponse<ApiResponce> = await http({
    url: `${from === 'precon' ? precondo_url : listing_url}${
     typeof arg === 'string' ? arg : arg.url
    }`,
    method: typeof arg === 'string' ? 'get' : arg.method,
    data: typeof arg === 'string' ? '' : arg.body,
    cancelToken: source.token,
    headers: {
     Authorization: `Bearer ${token}`,
     Accept: 'application/json',
    },
   })

   if (data?.status === 'success' || data.status === true || data.success) {
    return { data }
   }
   globalToaster({ type: 'error', content: data.message })
   return { error: { status: 400, data } }
  } catch (axiosError) {
   const err = axiosError as AxiosError
   return {
    error: { status: err.response?.status, data: err.response?.data },
   }
  }
 }

export default dynamicAxiosBaseQuery
